module.exports = __webpack_public_path__ + "static/identifier-assignment-cbcb3146d11cce085097d1062af15995.png";